import { render, staticRenderFns } from "./SetupBasicInfo.vue?vue&type=template&id=6805135f&scoped=true&"
import script from "./SetupBasicInfo.vue?vue&type=script&lang=js&"
export * from "./SetupBasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./SetupBasicInfo.vue?vue&type=style&index=0&id=6805135f&lang=less&scoped=true&"
import style1 from "./SetupBasicInfo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6805135f",
  null
  
)

export default component.exports